import { Route, Redirect } from "react-router-dom";
import { Spin } from "antd";
import { useAuth } from "context/AuthContext";
import { useAuthToken } from "hooks/auth/auth";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { authenticated } = useAuth();
  const { token: tokenNormalLogin } = useAuthToken();

  // Hiển thị loading trong khi chưa xác định trạng thái đăng nhập
  if (authenticated == null) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spin size="medium" />
      </div>
    );
  }

  // Ưu tiên idToken (authenticated === true), fallback sang token thường nếu có
  const hasAccess = authenticated || !!tokenNormalLogin;

  return (
    <Route
      {...rest}
      render={(props) =>
        hasAccess ? <Component key={props.match?.params?.id || "empty"} {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default PrivateRoute;
